import { LoadingScreen } from "../LoadingScreen";

export const LandingPage = () => {
  return <LoadingScreen />;
};
